<template>
  <div>
    <wg-modal
      v-if="openPicker"
      :portal="true"
      :width="windowWidth > 700 ? '400px' : '90%'"
      @closeModal="openPicker = false"
    >
      <div slot="body">
        <world-date-picker :from="$moment(sdInput).utc().format('X')" @customFunction="setDate"></world-date-picker>
      </div>
    </wg-modal>
    <!-- Nome -->
    <div class="wg-row">
      <div
        class="wg-col wg-xs-12 wg-sm-4 anm22-calendar-label-tiny-inline"
      >{{ $anm22.strLang(lang, 'Name', 'Nome') }}</div>
      <div class="wg-col wg-xs-12 wg-sm-8">
        <input
          :disabled="!canEdit"
          class="anm22-calendar-input-text"
          style="max-width:100%;"
          type="text"
          v-model="event.name"
          :placeholder="$anm22.strLang(lang, 'Reminder name', 'Nome promemoria')"
        />
      </div>
    </div>
    <div class="vertical-height-div" style="height:10px;"></div>
    <!-- Scelta calendario aziendale -->
    <div class="wg-row">
      <div
        class="wg-col wg-xs-12 wg-sm-4 anm22-calendar-label-tiny-inline"
      >{{$anm22.strLang(lang, 'Calendar', 'Calendario')}}</div>
      <div class="wg-col wg-xs-12 wg-sm-8">
        <select
          :disabled="!canEdit"
          required
          class="com-anm22-app-select"
          style="max-width:100%;"
          v-model="event.work"
        >
          <option value="0">{{ $anm22.strLang(lang, 'Private', 'Privato') }}</option>
          <option
            v-for="(obj,index) in works"
            :key="'work-'+index"
            :value="obj.idWorldWork"
          >{{ obj.name }}</option>
        </select>
      </div>
    </div>
    <div class="vertical-height-div" style="height:10px;"></div>
    <!-- Descrizione (campo note dell'evento) -->
    <div class="wg-row">
      <div
        class="wg-col wg-xs-12 wg-sm-4 anm22-calendar-label-tiny-inline"
      >{{ $anm22.strLang(lang, 'Description', 'Descrizione') }}</div>
      <div class="wg-col wg-xs-12 wg-sm-8">
      <div style="position:relative;">
      <textarea
        :disabled="!canEdit"
        style="margin:0;max-width:100%;padding-bottom:53px;"
        v-model="event.notes"
        rows="3"
      ></textarea>
      <template v-if="event.idWorldEvent && event.links.length == 0">
        <div style="position:absolute;bottom:0">
          <div class="icon-div desc-box">
            <img
              class="com-anm22-app-img-fixed-height-l" 
              style="padding:5px;height:100%;"
              :title="$anm22.strLang(lang, 'Add link', 'Aggiungi link')"
              :src="$anm22.icons.getWorldIcon('link')"
              @click="$emit('showLinkModal')"
            />
          </div>
        </div>
      </template>
    </div>
      </div>
    </div>
    <div class="vertical-height-div" style="height:10px;"></div>
    <!-- Data / Ora -->
    <div class="wg-row">
      <div
        class="wg-col wg-xs-12 wg-sm-4 anm22-calendar-label-tiny-inline"
      >{{ $anm22.strLang(lang, 'Time', 'Orario') }}</div>
      <div class="wg-col wg-xs-7 wg-sm-5">
        <div 
          v-if="canEdit"
          @click="openPicker=!openPicker;"
          class="input-date-picker-label">
         {{(startDateInput != "") ? startDateInput : "-" }}
        </div>
        <div 
          v-if="!canEdit"
          class="input-date-picker-label">
          {{(startDateInput != "") ? startDateInput : "-" }}
        </div>
      </div>
      <div class="wg-col wg-xs-5 wg-sm-3">
        <input :disabled="!canEdit" type="time" v-model="startTimeInput" />
      </div>
    </div>
    <div class="vertical-height-div" style="height:10px;"></div>
    <!-- Timezone -->
    <div class="wg-row">
      <div
        class="wg-col wg-xs-12 wg-sm-4 anm22-calendar-label-tiny-inline"
      >{{ $anm22.strLang(lang, 'Timezone', 'Fuso orario') }}</div>
      <div class="wg-col wg-xs-12 wg-sm-8">
        <select
          :disabled="!canEdit"
          class="com-anm22-app-select"
          style="max-width:100%;"
          v-model="event.timezone"
        >
          <option :value="null" disabled hidden>{{ $anm22.strLang(lang, 'Select', 'Seleziona') }}</option>
          <option
            v-for="(obj,key,index) in $anm22.tableClasses.worldTimezone().getAll()"
            :key="'timezone-'+index"
            :value="key"
          >{{ obj[lang] }}</option>
        </select>
      </div>
    </div>
    <div class="vertical-height-div" style="height:10px;"></div>
    <!-- Pulsanti -->
    <input
      v-if="canEdit"
      type="button"
      class="com-anm22-input-button"
      @click="save"
      :value="$anm22.strLang(lang, 'Save', 'Salva')"
    />
    <img v-if="showSaved" class="cont-tick" :src="$anm22.icons.getWorldIcon('tick')" />
  </div>
</template>

<script>
import { mapState } from "vuex";
import WorldDatePicker from "../../../../../../world/spa/components/WorldDatePicker.vue";

export default {
  props: {
    eventRef: Object,
    showSaved: Boolean
  },
  components : {
    WorldDatePicker
  },
  data() {
    return {
      openPicker:false,
      event: { ...this.eventRef },
      sd: '',
      sdInput: '',
      st: '',
      stInput: ''
    };
  },
  computed: {
    ...mapState({
      windowWidth: state => state.windowWidth,
      user: state => state.auth.user,
      lang: state => state.lang
    }),
    works() {
      return this.$store.getters["works/getAll"];
    },
    canEdit() {
      const invites = this.$store.getters["invites/getByEvent"](
        this.event.idWorldEvent
      );
      return (
        !this.event.idWorldEvent ||
        invites.find(
          i => i.user === this.user.idWorldUser && i.permission == 1
        ) !== -1
      );
    },
    startDate: {
      get() {
        return this.sd;
      },
      set: function(newDate){
        this.sd = newDate;
      }
    },
    startTime: {
      get() {
        return this.st;
      },
      set: _.debounce(function(newTime){
        this.st = newTime;
      }, 1000)
    },
    startDateInput: {
      get() {
        return this.sd;
      },
      set: function(newDate){
        // Controllo che sia nel formato giusto
        this.sdInput = this.$anm22.parseInputDate(newDate);
        // debounced
        this.startDate = this.sdInput;
      }
    },
    startTimeInput: {
      get() {
        return this.st;
      },
      set: function(newTime){
        // Controllo che sia nel formato giusto
        this.stInput = this.$anm22.parseInputTime(newTime);
        this.startTime = this.stInput;
      }
    },
    // eventDate: {
    //   get() {
    //     return this.$moment
    //       .unix(this.event.startTimestamp)
    //       .format("YYYY-MM-DD");
    //   },
    //   set: _.debounce(function(newVal) {
    //     this.event.startTimestamp = Number(
    //       this.$moment(newVal + " " + this.eventTime).unix()
    //     );
    //     this.event.endTimestamp = this.event.startTimestamp;
    //   }, 1000)
    // },
    // eventTime: {
    //   get() {
    //     return this.$moment.unix(this.event.startTimestamp).format("HH:mm");
    //   },
    //   set: _.debounce(function(newTime) {
    //     this.event.startTimestamp = Number(
    //       this.$moment(this.eventDate + " " + newTime).unix()
    //     );
    //     this.event.endTimestamp = this.event.startTimestamp;
    //   }, 1000)
    // }
  },
  methods: {
    setDate(newDate) {
      this.sdInput = this.$anm22.parseInputDate(newDate);
      this.startDate = this.sdInput;
      this.openPicker = false;
    },
    // setDate(newDate) {
    //   let time = this.$moment.unix(this.event.startTimestamp).format("HH:mm");
    //   let date = newDate + " " + time;
    //   let ts = this.$moment(date).unix();
    //   if (isNaN(ts)) {
    //     this.event.startTimestamp = "";
    //   } else if (ts) {
    //     this.event.startTimestamp = ts;
    //   }
    //   this.event.endTimestamp = this.event.startTimestamp;
    //   this.openPicker = false;
    // },
    save() {
      this.sd = this.sdInput || this.sd;
      this.st = this.stInput || this.st;
      // Collego timezone e date
      this.event.startTimestamp = this.$moment.tz(this.sd + ' ' + this.st, this.event.timezone).unix();
      this.event.endTimestamp = this.$moment.tz(this.sd + ' ' + this.st, this.event.timezone).unix();
      this.$emit('save', this.event);
    }
  },
  created() {
    this.sd = this.sdInput = this.$moment.unix(this.event.startTimestamp).tz(this.event.timezone).format('YYYY-MM-DD');
    this.st = this.stInput = this.$moment.unix(this.event.startTimestamp).tz(this.event.timezone).format('HH:mm');
  }
};
</script>

<style lang="scss" scoped>
.cont-tick {
  display: inline-block;
  height: auto;
  margin-left: 11px;
  width: 24px;
}
.icon-div {
  border-radius: 30px;
  width: 50px;
  height: 50px;
  border:1px solid #9999;
  background-position: center;
  background-repeat: no-repeat;
  background-size: 40px 40px;
  padding: 5px;
  margin: 5px 10px;
  cursor: pointer;
  &:hover {
    border: none;
    background-color: #eee;
  }
}
.input-date-picker-label {
  width: 100%;
  max-width: 300px;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  box-sizing: border-box;
  padding: 10px;
  border-radius: 4px;
  display: block;
  box-shadow: none;
  background-color: #eee;
  border: 1px solid #eee;
  height: 36px;
  font-size: 12px;
  cursor: pointer;
}
.icon-div.desc-box {
  border: none;
  width: 40px;
  height: 40px;
  padding: 2px;
  background-color:#eee;
  &:hover {
    background-color:#ddd;
  }
}
</style>